import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { isPatient } from 'utils/userTypeHelper';
import ArrowUpIcon from 'components/atoms/icons/arrowUpIcon';
import ArrowDownIcon from 'components/atoms/icons/arrowDownIcon';
import useUser from 'utils/useUser';
import ActivityRow from './activityRow';
import RpmCommentModal from './modal';

const ActivityTable = ({
  handleCommentSubmit,
  handleReviewedCheck,
  submitCommentLoading,
  actionReviewLoading,
  patient,
  reviewed,
  activity,
}) => {
  const { userType } = useUser();
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalActivity, setModalActivity] = useState(null);
  const { sort, itemsPerPage, page } = useSelector((state) => state.activity);
  const {
    activity: { toggleActivitiesTimeSort },
  } = useDispatch();

  const openModal = (props) => {
    if (!isModalOpen) {
      setModalActivity(props);
      setModalOpen(true);
    }
  };

  const columnNumber = (index) =>
    page * itemsPerPage + index + 1 - itemsPerPage;

  return (
    <div className="table-outer">
      <Table borderless cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th className="table-status-column">№</th>
            <th className="table-status-column">Status</th>
            <th className="table-time-column">
              Time
              <button
                className="button-sort-arrow"
                onClick={() => {
                  toggleActivitiesTimeSort({
                    patientGuid: patient?.profile?.guid,
                    clinicGuid: patient?.clinic?.clinicGuid,
                    userType,
                  });
                }}
              >
                {sort.time ? <ArrowUpIcon /> : <ArrowDownIcon />}
              </button>
            </th>
            <th className="table-reading-column">Reading</th>
            {!isPatient(userType) && (
              <>
                <th className="table-comment-column">Comment</th>
                {!reviewed && (
                  <th className="table-reviewed-column">Reviewed</th>
                )}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {activity.data.map((activityRow, index) => (
            <ActivityRow
              key={`${activityRow.id}-${index}`}
              columnNumber={columnNumber(index)}
              activity={activityRow}
              handleCommentSubmit={handleCommentSubmit}
              handleReviewedCheck={handleReviewedCheck}
              reviewed={reviewed}
              setReviewedLoading={actionReviewLoading}
              submitCommentLoading={submitCommentLoading}
              thresholds={patient.thresholds}
              disabledModalButton={isModalOpen}
              openModal={openModal}
            />
          ))}
        </tbody>
      </Table>
      {isModalOpen && (
        <RpmCommentModal
          isOpen={isModalOpen}
          closeModal={() => setModalOpen(false)}
          activityProps={modalActivity}
        />
      )}
    </div>
  );
};

ActivityTable.propTypes = {
  handleCommentSubmit: PropTypes.func.isRequired,
  handleReviewedCheck: PropTypes.func.isRequired,
  submitCommentLoading: PropTypes.bool.isRequired,
  actionReviewLoading: PropTypes.bool.isRequired,
  patient: PropTypes.shape(),
  activity: PropTypes.shape(),
  reviewed: PropTypes.bool,
};

export default ActivityTable;
